export class CrmTagApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getTags(params) {
    return this.#http.get('/api/crm-tags', { params });
  }

  async getTagById(tagId) {
    return this.#http.get(`/api/crm-tags/${tagId}`);
  }

  async createTag(body) {
    return this.#http.post('/api/crm-tags', body);
  }

  async updateTag({ tagId, ...body }) {
    return this.#http.put(`/api/crm-tags/${tagId}`, body);
  }

  async deleteTag(tagId) {
    return this.#http.delete(`/api/crm-tags/${tagId}`);
  }
}
